module.exports = __webpack_public_path__ + "media/Video 29.7181cc7e.mp4";